import React, { useMemo, useRef } from 'react';
import styled from 'styled-components/macro';

import { viewport } from '../../../../common/config';
import Container from '../Container'
import { getVh } from '../utils';
import useTriggerAnimation from '../useTriggerAnimation';

const Uno = styled.img`
  aspect-ratio: 1156/1504;
  width: auto;
  height: 55vh;

  transform: translateY(-50%);
`;

const Dos = styled.img`
  aspect-ratio: 360/167;
  width: auto;
  height: 40vh;

  transform: translateY(-50%);

  @media screen and (min-width: ${viewport.sm}) {
    transform: translateY(-45%);
  }

  @media screen and (min-width: ${viewport.lg}) {
    transform: translateY(-30%);
  }
`;

const Hands = () => {
  const ref = {
    uno: useRef<HTMLElement>(null),
    dos: useRef<HTMLElement>(null)
  }

  const top = {
    uno: useMemo(() => getVh("history", 0.5), []),
    dos: useMemo(() => getVh("contact", 0.5), [])
  }

  useTriggerAnimation(ref.uno, top.uno);
  useTriggerAnimation(ref.dos, top.dos);

  return (
    <>
      <Container
        ref={ref.uno}
        top={top.uno}
        style={{ left: "60vw" }}
      >
        <Uno src="/static/images/outline/hand/1.png" />
      </Container>

      <Container
        ref={ref.dos}
        top={top.dos}
        style={{ left: "55vw" }}
      >
        <Dos src="/static/images/outline/hand/2.png" />
      </Container>
    </>
  );
}

export default Hands;